import { SPAM_WORDS } from "./spam";
import { LINKS } from "./links";

export const ANTI_BOT = {
  email: {
    value: 'testsuptestporttest@slattestepages.cotestm',
    title: 'support email',
  },
  phone: {
    value: 'test515test75test8test5463',
    title: 'phone number',
  },
};

export const STATUS = {
  success: 'success',
  error: 'error',
};

export const HELPFUL_RESOURCES = [
  {
    title: 'Product Support',
    to: LINKS.support,
    description: 'browse topics',
  },
  // {
  //   title: 'Miscellaneous',
  //   to: '',
  //   description: 'browse topics',
  // },
];

const blankField = name => (`Please provide ${name}`)

export const ERRORS_TEXT = {
  email: blankField('your email'),
  name: blankField('your name'),
  phone: blankField('your phone'),
  last_name: blankField('your last name'),
  subject: blankField('subject'),
  message: blankField('message'),
  reason: blankField('reason'),
  how_did_you_hear_about_us: blankField('an answer'),
  organization: blankField('your organization’s name'),
}

export function validateEmail(email) {
  let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return re.test(String(email).toLowerCase());
}

export async function postData(url = '', data = {}) {
  return await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  })
    .then( response => {
      if (!response.ok) {
        throw new Error();
      }
      return response.json()
    });
}

export const checkSpamWords = text => {
  let wordsList = [];

  SPAM_WORDS.forEach( spamWord => {
    if(text.toLowerCase().trim().includes(spamWord.toLowerCase().trim())){
      wordsList.push(spamWord)
    }
  })

  if(!wordsList.length) {return ''}
  if(wordsList.length > 1){
    return `These words: ${wordsList.join()} look like spam. 
    Please replace the words listed with synonyms.`
  } else {
    return `This word: ${wordsList.join()} sounds like spam. 
            Please replace it with a synonym.`
  }
};
